/* eslint-disable */
/* tslint-disable */
// @ts-nocheck
import AdadaptedJsSdk from '@adadapted/js-sdk/src'
import { inject, Service, service } from './di'
import { EVTrackingService } from './EVTrackingService'
import { ConfigService } from './ConfigService'
import { LocationService } from './LocationService'
import { generateUUID, getSessionId } from '../utils/uuid'
import { EventService } from './EventService'
import { ShoppingListService, SLListItem } from './ShoppingListService'
import {
    ShoppingListAction,
    ShoppingListEventContext,
} from './definitions/IAnalyticsService'
import { AnalyticsService } from './AnalyticsService'
import { ReleaseService } from './ReleaseService'
import { keys, values } from 'lodash-es'
import { AdBlockerDetectionService } from './AdBlockerDetectionService'

export type FlyerListAdSlotConfig = {
    [deviceType: string]: number
}

export type FlyerListAdSlotsConfig = {
    [position: string]: FlyerListAdSlotConfig
}

export const FLYER_LIST_AD_SLOTS_WRAPPER_NAME = 'flyer-list-ad-slots-wrapper'
export const FLYER_LIST_AD_SLOT_NAME_BASE = 'flyer-list-ad-slot'

export const FLYER_LIST_AD_SLOTS_CONFIG: FlyerListAdSlotsConfig = {
    '1': { desktop: 102195, tablet: 102196, mobile: 102210 },
    '7': { desktop: 102208, tablet: 102209, mobile: 102211 },
}

@service('adAdaptedService')
export class AdAdaptedService extends Service {
    @inject evTracker: EVTrackingService
    @inject config: ConfigService
    @inject location: LocationService
    @inject eventService: EventService
    @inject sl: ShoppingListService
    @inject analytics: AnalyticsService
    @inject releaseService: ReleaseService
    @inject adBlockerDetectionService: AdBlockerDetectionService

    private _aaSdk: AdadaptedJsSdk
    private _shouldDisplayAd = true

    async init() {
        if (!this.releaseService.shouldUseAdAdapted) return

        this._aaSdk = new AdadaptedJsSdk()
        const localeArr = this.location.locale.split('-')
        const deviceLocale = `${localeArr[0]}-${localeArr[1].toUpperCase()}`

        const zonePlacements = keys(FLYER_LIST_AD_SLOTS_CONFIG).reduce(
            (acc: any, position: string) => {
                const item = FLYER_LIST_AD_SLOTS_CONFIG[position]
                values(item).forEach((zoneId) => {
                    acc[zoneId] = `${FLYER_LIST_AD_SLOT_NAME_BASE}-${zoneId}`
                })
                return acc
            },
            {}
        )
        return this._aaSdk.initialize({
            apiKey: this.config.ADADAPTED_API_KEY,
            advertiserId: getSessionId(),
            allowRetargeting: true,
            deviceLocale,
            zonePlacements,
            apiEnv: this.config.ADADAPTED_ENV as any,
            scrollContainerId: 'scrollableContainer',
            onAddItemsTriggered: (items) => {
                const names = items.map((item) => item.product_title)
                names.forEach((name) => {
                    this.sl.addItemToShoppingList(name)
                })
                this.eventService.displayAddedItemPopup(items.length)
                this._aaSdk.reportItemsAddedToList(names)
                this._aaSdk.acknowledgeAdded()
                const item = items.reduce((acc, item, currentIndex) => {
                    return currentIndex === 0
                        ? acc + item.product_title
                        : acc + ',' + item.product_title
                }, items.length.toString())
                this.analytics.trackShoppingListChanged(
                    item,
                    this.sl.localList.id,
                    ShoppingListAction.Add,
                    ShoppingListEventContext.AdAdapted
                )
            },
            onAdsRetrieved: (adZoneAdAvailabilityMap) => {
                this.eventService.adLoaded(adZoneAdAvailabilityMap)
            },
        })
    }

    shouldDisplayAd() {
        return (
            this._shouldDisplayAd &&
            this.releaseService.shouldUseAdAdapted &&
            !this.adBlockerDetectionService.isDetected()
        )
    }

    disableAd() {
        this._shouldDisplayAd = false
    }

    async reportItemsAddedToList(items: string[]) {
        if (!this._aaSdk) await this.init()
        this._aaSdk.reportItemsAddedToList(items)
    }

    async reportItemsRemovedFromList(items: string[]) {
        if (!this._aaSdk) await this.init()
        this._aaSdk.reportItemsDeletedFromList(items)
    }
}
/* eslint-enable */
/* tslint-enable */
